import {createContext} from 'react'

export interface IOnlineWatcherContext {
  isOnline: boolean
}

export const OnlineWatcherContext = createContext<IOnlineWatcherContext>({
  isOnline: true,
})
